module.exports = __webpack_public_path__ + "img/ensure-4.257f3757.png";